import React from "react";

// "X of 6 correct": the same line, styling and position on round 1's Results
// screen and on every compact screen after it.
export default function Score({ correct, total }) {
  return (
    <div className="mt-3 rounded-xl border border-gray-200 px-4 py-3">
      <p className="font-semibold text-bodyInk">
        {correct.length} of {total} correct
      </p>
      <p className="sr-only">Correct: {correct.map((c) => c.label).join(", ") || "none"}.</p>
    </div>
  );
}
